import React from "react";
import { useNavigate } from "react-router-dom";

interface GameOverScreenProps {
  streakNumber: number;
  handlePlayAgain: Function;
  pokemon: any;
}
const GameOverScreen = ({ streakNumber, handlePlayAgain, pokemon }: GameOverScreenProps) => {
  const navigate = useNavigate();
  const handleOnClick = (e: any) => {
    e.preventDefault();
    handlePlayAgain();
  };

  return (
    <div className="w-full">
      <div>
        <h1 className="text-3xl font-bold">Game Over!</h1>
        <h3 className="text-xl text-gray-500"> The pokemon was {pokemon.name}</h3>
        <h3 className="text-xl text-gray-500">Pokemon guessed correctly: {streakNumber}</h3>
        <h3 className="text-xl">Play again?</h3>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
          onClick={handleOnClick}
        >
          Play Again
        </button>
        <h3 className="text-xl mt-2">or</h3>
        <button
          className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded mt-2"
          onClick={() => navigate("/")}
        >
          Navigate back to projects
        </button>
      </div>
    </div>
  );
};

export default GameOverScreen;
